var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _polygon, _path8, _polygon2, _path9, _path0, _path1, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationSizeWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 671.54884,
    height: 517.60997,
    viewBox: "0 0 671.54884 517.60997",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M598.31235,319.69325c-21.382-5.32231-39.73961-15.78433-54.091-33.05485a4.84488,4.84488,0,0,1-1.60593-6.65284l24.96376-40.85071a4.84485,4.84485,0,0,1,6.65282-1.60591l54.091,33.05486a4.84484,4.84484,0,0,1,1.60594,6.65281l-24.96375,40.85071A4.84486,4.84486,0,0,1,598.31235,319.69325Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M583.88948,306.5758c-11.25811-1.229-22.95865-10.227-34.7746-21.25066a4.53726,4.53726,0,0,1-1.504-6.23058l21.45424-35.10775a4.53747,4.53747,0,0,1,6.2307-1.5042l48.13364,29.41433a4.53746,4.53746,0,0,1,1.50388,6.23077l-13.29046,21.74852A20.21113,20.21113,0,0,1,583.88948,306.5758Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M688.31235,384.69325c-21.382-5.32231-39.73961-15.78433-54.091-33.05485a4.84488,4.84488,0,0,1-1.60593-6.65284l24.96376-40.85071a4.84485,4.84485,0,0,1,6.65282-1.60591l54.091,33.05486a4.84484,4.84484,0,0,1,1.60594,6.65281l-24.96375,40.85071A4.84486,4.84486,0,0,1,688.31235,384.69325Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M673.88948,371.5758c-11.25811-1.229-22.95865-10.227-34.7746-21.25066a4.53726,4.53726,0,0,1-1.504-6.23058l21.45424-35.10775a4.53747,4.53747,0,0,1,6.2307-1.5042l48.13364,29.41433a4.53746,4.53746,0,0,1,1.50388,6.23077l-13.29046,21.74852A20.21113,20.21113,0,0,1,673.88948,371.5758Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M617.31235,410.69325c-21.382-5.32231-39.73961-15.78433-54.091-33.05485a4.84488,4.84488,0,0,1-1.60593-6.65284l24.96376-40.85071a4.84485,4.84485,0,0,1,6.65282-1.60591l54.091,33.05486a4.84484,4.84484,0,0,1,1.60594,6.65281l-24.96375,40.85071A4.84486,4.84486,0,0,1,617.31235,410.69325Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M602.88948,397.5758c-11.25811-1.229-22.95865-10.227-34.7746-21.25066a4.53726,4.53726,0,0,1-1.504-6.23058l21.45424-35.10775a4.53747,4.53747,0,0,1,6.2307-1.5042l48.13364,29.41433a4.53746,4.53746,0,0,1,1.50388,6.23077l-13.29046,21.74852A20.21113,20.21113,0,0,1,602.88948,397.5758Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M350.39209,686.991a2.80741,2.80741,0,0,1-2.03464-4.86593l.19236-.76476q-.038-.09189-.07643-.18358a7.5391,7.5391,0,0,0-13.90674.05167c-2.27452,5.4781-5.17037,10.96553-5.8834,16.75771a22.30363,22.30363,0,0,0,.39152,7.67061,89.41963,89.41963,0,0,1-8.13413-37.13875,86.307,86.307,0,0,1,.53535-9.62829q.44351-3.93128,1.23056-7.80653a90.45545,90.45545,0,0,1,17.93812-38.33731,24.07276,24.07276,0,0,0,10.0118-10.38734,18.36283,18.36283,0,0,0,1.67-5.01791c-.48739.06393-1.83779-7.35909-1.47018-7.81452-.67924-1.03071-1.895-1.54307-2.6368-2.54885-3.68944-5.0021-8.77254-4.12872-11.42613,2.66876-5.66869,2.861-5.72356,7.60577-2.24528,12.16916,2.2129,2.90324,2.517,6.83168,4.45862,9.93984-.1998.25571-.40755.50344-.60729.75916a91.03873,91.03873,0,0,0-9.50223,15.05378,37.846,37.846,0,0,0-2.25945-17.5787c-2.16269-5.21725-6.21632-9.61123-9.786-14.12153-4.28781-5.41757-13.08034-3.05324-13.83576,3.81438q-.011.09975-.02141.19942.79533.44867,1.55706.95247a3.808,3.808,0,0,1-1.53532,6.92992l-.07766.012a37.88985,37.88985,0,0,0,.99877,5.66515c-4.5795,17.71009,5.3073,24.16047,19.42431,24.45023.31164.15979.61532.31958.927.47144a92.9244,92.9244,0,0,0-5.00193,23.53931,88.13549,88.13549,0,0,0,.06393,14.23066l-.024-.16777a23.28924,23.28924,0,0,0-7.95037-13.44764c-6.11821-5.02589-14.76211-6.87666-21.36258-10.9165a4.37072,4.37072,0,0,0-6.69422,4.252q.01327.08819.027.17642a25.57976,25.57976,0,0,1,2.86848,1.38225q.79533.44877,1.55707.95247a3.8081,3.8081,0,0,1-1.53534,6.93l-.07771.01193c-.05591.008-.10388.016-.15973.024a37.92284,37.92284,0,0,0,6.97545,10.92265c2.86344,15.46021,15.162,16.927,28.31754,12.42488h.008a92.89719,92.89719,0,0,0,6.24044,18.21781h22.2928c.08-.24769.15184-.50341.22378-.75113a25.32946,25.32946,0,0,1-6.16855-.36745c1.654-2.02957,3.308-4.07513,4.962-6.10463a1.38576,1.38576,0,0,0,.10388-.11987c.839-1.03867,1.68594-2.06945,2.52491-3.10816l.00044-.00127a37.10115,37.10115,0,0,0-1.08711-9.45126Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#f2f2f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.07687,
    cy: 119.62067,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "67.218 490.329 76 496.038 102.202 464.885 89.242 456.458 67.218 490.329",
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M325.178,690.48333l27.00345,17.55859.222-.34146a12.53774,12.53774,0,0,0-3.67564-17.34476l-.00065-.00042-2.499-6.94943-11.6365-2.24192-2.35721-1.53279Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.708 505.29 228.183 505.289 233.165 464.888 217.706 464.889 217.708 505.29",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M481.56512,707.41213l32.21009-.00123v-.4073a12.53776,12.53776,0,0,0-12.53707-12.53688h-.00077l-5.88357-4.46355-10.97746,4.46426-2.81174.00007Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#2f2e41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M373.514,447.18174l93.928,2.0652,9.31029,11.63786s-.80515-4.10317-.08854.40351,18.83727,94.3619,15.41192,97.37545,6.49516,23.82026,7.22375,25.08922,8.5817,63.89956,0,69.04954l-3.22375,21.86124h-15s-15.02654-17.38937-12.00253-20.54167-5.62494-13.63452-5.95561-19.25541-3.48856-31.11519-1.04186-35.20292,5.75426-19.42831-.45259-25.37553-35.155-79.02951-35.155-79.02951-8.41218,85.6776-8.39241,92.405c.0257,8.74882-5.71952,4.41887-5.71952,12.09946,0,1.55171-18.70753,41.43415-31.28048,53.90054l-26,20-12-9v-13s11.12071-24.12072,15-28,18.20312-15.754,18.20312-21.185,6.74294-7.3231,2.20768-14.52355-2.98353-10.30388-1.43182-13.40731-1.3909-130.25955-1.3909-130.25955Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#2f2e41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M391.29852,269.79033l40.75355-1.95809,10.42871,17.10869s30.4599,3.05718,26.10411,14.51351-11.0791,90.01009-4.92112,99.83387c3.24941,5.18374,8.75,22.532,13.22124,37.76365a19.46633,19.46633,0,0,1-19.31931,24.93032c-28.987-.95582-72.03686-3.22149-77.12918-8.31381-7.75857-7.75857-14.74128-13.96543-10.08614-16.293s11.31339-36.08716,11.31339-36.08716-30.90913-97.3621-22.84174-100.23008,30.58878-16.1173,30.58878-16.1173Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.45437,
    cy: 39.05862,
    r: 28.38294,
    fill: "#ffb6b6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.41,708.49768l315.3575.30731a1.19069,1.19069,0,0,0,0-2.38135L265.41,706.11633a1.19069,1.19069,0,0,0,0,2.38135Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#cacaca"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M390.005,458.02976l-7.98944-24.05048-14.37579,2.64714,9.35167,25.12711a8.48372,8.48372,0,1,0,13.01356-3.72377Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.14271,301.26685l-.379.1579a23.49832,23.49832,0,0,0-13.96051,16.89678c-2.03769,9.753-4.04257,23.85962-2.45745,37.06875,2.79946,23.32907,4.6658,33.59384,8.39846,41.05915s4.66581,4.6658,3.73264,10.2648-5.599.93316-.93317,8.39846,7.4653,5.599,5.599,9.33164-4.6658,3.73263-.93317,8.39847,3.73264,6.53213,4.66581,8.39846S368.608,457.105,368.608,457.105s14.93061-4.66583,23.329-2.7995c0,0-7.46533-13.06427-5.599-15.86376s4.66584-3.73267,1.86634-6.53214-7.46534-1.86633-2.7995-4.66583-3.73267-31.72751-3.73267-31.72751Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M585.60839,354.41478l-24.568-6.21868-5.51059,13.539,26.2087,5.65056a8.48372,8.48372,0,1,0,3.86985-12.97086Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#ffb6b6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M437.97265,294.32044l-.071.40438a23.49829,23.49829,0,0,0,6.72025,20.86228c7.12094,6.96888,17.92807,16.25449,29.9121,22.03176,21.16535,10.20346,30.81979,14.15826,39.1203,15.033s6.444-1.4191,10.65944,2.38221-2.22866,5.2204,6.57434,5.30877,8.73787-3.27553,10.87814.30705.63278,5.94154,6.57434,5.30878,7.51418.37222,9.58931.5909,15.37733,5.39718,15.37733,5.39718,4.10833-15.09353,10.20341-21.16534c0,0-15.02838-.74439-16.38234-3.82452s-.63278-5.94158-4.4992-5.0901-5.59262,5.28555-5.43908-.15353-100.52619-54.42491-100.52619-54.42491Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M446.66377,225.28831c-3.06.95-6.01,1.51-8-1s-1.47-5.38-4.43-6.59a10.47,10.47,0,0,0-7.56.35c-.43.16-.85.34-1.26.52-.23-.2-.46-.38995-.71-.57a9.01841,9.01841,0,0,0-6.49-1.58,8.84873,8.84873,0,0,1,3.93,3.75c-.82.41-1.65.82-2.49,1.17a24.55294,24.55294,0,0,1-21.91-1.66c3.28,8.63995.73,11.72-4.08,19.61l-.19.46c.48-2.06995-5.81-4.46-5.81-1.46a35.83377,35.83377,0,0,0,2,9c-6.17-9.29-9.81-20.16-7.42-30.59.51-2.19.74-4.54,2.13-6.32,1.39-1.77,3.95-2.81,5.97-1.81a18.81819,18.81819,0,0,1,30.28-13.5c2.5,1.93,4.47,4.46,6.7,6.71,2.23,2.25,4.87,4.3,7.99,4.86,1.98.35,4.21.14,5.79,1.39,1.83,1.45,1.85,4,1.84,6.45a9.00823,9.00823,0,0,0-5.07,1.38995,8.81453,8.81453,0,0,1,5.12,1.8.54925.54925,0,0,1,.08.06C443.61379,221.8483,443.39375,222.71836,446.66377,225.28831Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.11593,
    cy: 47.19191,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.47268,
    cy: 53.32707,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.76671,
    cy: 92.17273,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.3942,
    cy: 197.31199,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 340.62175,
    cy: 221.41244,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.57481,
    cy: 211.62477,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.93567,
    cy: 172.77911,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.99839,
    cy: 71.98734,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.716,
    cy: 120.92569,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.88837,
    cy: 99.39282,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.33149,
    cy: 147.02615,
    rx: 5.2392,
    ry: 5.22009,
    fill: "#e6e6e6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.00592,
    cy: 148.33117,
    rx: 15.06271,
    ry: 15.00776,
    fill: "#49BCD2"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.34725,
    cy: 176.38916,
    rx: 15.06271,
    ry: 15.00776,
    fill: "#49BCD2"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.35513,
    cy: 84.38506,
    rx: 15.06271,
    ry: 15.00776,
    fill: "#49BCD2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M595.95147,269.61527c24.43221-7.59244,50.58762.61838,75.15392-6.38972a50.94433,50.94433,0,0,0,15.78879-7.41535,98.119,98.119,0,0,0,11.49179-10.227c7.39-7.30911,15.41513-14.9839,26.51777-14.89924,14.62051.11149,25.84644,10.9719,35.59159,20.5616,1.37734,1.35538,3.5002-.76443,2.12132-2.12132-8.95478-8.81193-18.62961-18.10832-31.37588-20.7387a28.95461,28.95461,0,0,0-17.11635,1.4219,44.68443,44.68443,0,0,0-12.719,8.69692c-3.925,3.59982-7.54555,7.5191-11.52413,11.06193a47.97248,47.97248,0,0,1-14.136,8.92233c-11.2619,4.48439-23.61538,5.02536-35.59332,4.89486-15.03629-.16383-30.431-1.18785-44.998,3.33892-1.83778.5711-1.05349,3.46805.79752,2.89284Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M765.85328,231.02754l7.51052,13.23972,3.63413,6.40631c.64582,1.13847,1.30943,2.26876,1.9382,3.41671.38621.7051,1.23,1.977.42432,2.64514a3.91283,3.91283,0,0,1-2.28294.35627c-1.32387.00282-2.64866-.02683-3.97248-.04024l-7.44838-.07546-15.39333-.156a1.5009,1.5009,0,0,0,0,3c8.93622.09053,17.87759.27926,26.81419.27165a6.41234,6.41234,0,0,0,4.3853-1.1997,4.17165,4.17165,0,0,0,.79536-4.80909,45.67937,45.67937,0,0,0-3.03324-5.56411l-3.27072-5.76569-7.51052-13.23972a1.50112,1.50112,0,0,0-2.59041,1.51416Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M865.12265,263.46915H796.092a2.87631,2.87631,0,1,1,0-5.75258h69.03069a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#49BCD2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M865.12265,309.79746H796.092a2.87631,2.87631,0,1,1,0-5.75258h69.03069a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M932.8879,286.63331H796.092a2.87631,2.87631,0,1,1,0-5.75258H932.8879a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M833.68742,405.71663H764.65674a2.87631,2.87631,0,1,1,0-5.75258h69.03068a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#49BCD2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M833.68742,452.04493H764.65674a2.87631,2.87631,0,1,1,0-5.75258h69.03068a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M901.45267,428.88078H764.65674a2.87631,2.87631,0,1,1,0-5.75258H901.45267a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M527.194,455.96H458.16326a2.87631,2.87631,0,1,1,0-5.75258H527.194a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#49BCD2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M527.194,502.28831H458.16326a2.87631,2.87631,0,1,1,0-5.75258H527.194a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M594.9592,479.12415H458.16326a2.87631,2.87631,0,1,1,0-5.75258H594.9592a2.87631,2.87631,0,1,1,0,5.75258Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M673.6028,339.81181l51.61526,38.9408,14.69049,11.08315c1.5414,1.1629,3.038-1.44074,1.51416-2.59041l-51.61526-38.9408L675.117,337.22139c-1.5414-1.1629-3.038,1.44074-1.51416,2.59042Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M717.52367,392.21191a92.03513,92.03513,0,0,0,35.96966,8.97749,1.51505,1.51505,0,0,0,1.44642-1.89876L746.94626,367.207c-.46648-1.87232-3.3604-1.07915-2.89284.79752l7.99349,32.08361,1.44642-1.89876a88.31083,88.31083,0,0,1-34.45551-8.5679c-1.73267-.83058-3.25629,1.7553-1.51415,2.59041Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M599.62563,366.89406l-37.08875,53.04255-10.45359,14.95022c-1.10875,1.58568,1.49089,3.08664,2.59041,1.51416l37.08875-53.04256L602.216,368.40822c1.10875-1.58569-1.49089-3.08665-2.59041-1.51416Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M548.814,412.69518a91.15613,91.15613,0,0,0-7.60845,36.161,1.51471,1.51471,0,0,0,1.89876,1.44642l31.85933-9.22845a1.50128,1.50128,0,0,0-.79752-2.89284l-31.85933,9.22845,1.89876,1.44642a87.48727,87.48727,0,0,1,7.19886-34.64689c.76209-1.75282-1.82175-3.2821-2.59041-1.51416Z",
    transform: "translate(-264.22558 -191.19501)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationSizeWork);
export default __webpack_public_path__ + "static/media/Organization-sizeWork.6c78701553003ca9abeadea85e6324bc.svg";
export { ForwardRef as ReactComponent };